<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'cl'" id="trading-container" data-cy="trading-container">
      <Tabs
        class="mt-6"
        :options="options"
        :callback="getCompletedAppraisals">
        <template #0>
          <AppraisalProcess />
        </template>
        <template #1>
          <AppraisalHistory
            :appraisal-list="appraisalList"
            @filter-estado-actualizado="filter"
            @filter-comprador-actualizado="filter"
            @filter-tipo-venta-actualizado="filter"
            @filter-usuario-actualizado="filter"
            @filter-fecha-actualizado="filter" />
        </template>
      </Tabs>
    </div>
  </div>
</template>

<script>
import Tabs from '@/ui/components/Tabs.vue';
import AppraisalHistory from '@/ui/views/internal/trading/AppraisalHistory.vue';
import { getAppraisalsByTradingStatus } from '@/application/services/api-clients/appraisal';
import { get } from '@/infrastructure/lodash';
import Message from '@/ui/components/Message.vue';
import AppraisalProcess from './AppraisalProcess.vue';

export default {
  components: {
    AppraisalHistory,
    Tabs,
    AppraisalProcess,
    Message
  },
  props: {
    historyIndex: { type: Number },
    index: { type: Number }
  },
  data() {
    return {
      options: [
        {
          label: 'Procesar',
          icon: 'cog'
        },
        {
          label: 'Histórico',
          icon: 'list'
        }
      ],
      appraisalList: [],
      originalAppraisalList: [],
      filterEstado: [],
      filterComprador: [],
      filterTipoVenta: [],
      filterUsuario: '',
      filterFecha: []
    };
  },
  methods: {
    async getCompletedAppraisals(index) {
      if (index === 'Histórico') {
        // TODO: elegir el estado con un filtro en el front
        this.appraisalList = (await getAppraisalsByTradingStatus('COMPLETED'));
        this.originalAppraisalList = this.appraisalList;
      }
    },
    filter(event) {
      const eventValue = JSON.parse(JSON.stringify(event.value));
      if (event.eventName === 'filter-estado-actualizado') {
        this.filterEstado = eventValue;
      } else if (event.eventName === 'filter-comprador-actualizado') {
        this.filterComprador = eventValue;
      } else if (event.eventName === 'filter-tipo-venta-actualizado') {
        this.filterTipoVenta = eventValue;
      } else if (event.eventName === 'filter-usuario-actualizado') {
        this.filterUsuario = eventValue;
      } else if (event.eventName === 'filter-fecha-actualizado') {
        this.filterFecha = eventValue;
      }

      this.appraisalList = this.originalAppraisalList;

      this.appraisalList = this.appraisalList.filter(appraisal => {
        return this.filterEstado.indexOf(appraisal.processingStatus) !== -1;
      });

      this.appraisalList = this.appraisalList.filter(appraisal => {
        return this.filterComprador.indexOf(appraisal.investorName) !== -1;
      });

      this.appraisalList = this.appraisalList.filter(appraisal => {
        return this.filterTipoVenta.indexOf(appraisal.salesType) !== -1;
      });

      const userId = get(this, '$store.state.currentUser.user._id');
      if (this.filterUsuario === 'Yo' && typeof userId !== 'undefined') {
        this.appraisalList = this.appraisalList.filter(appraisal => {
          return userId === appraisal.userId;
        });
      }

      if (this.filterFecha.length === 2 && this.filterFecha[0].length >= 10 && this.filterFecha[1].length >= 10) {
        this.appraisalList = this.appraisalList.filter(appraisal => {
          const desde = new Date(this.filterFecha[0].substring(0, 10));
          const hasta = new Date(this.filterFecha[1].substring(0, 10));
          const fechaEndoso = new Date(appraisal.salesDate);
          return fechaEndoso >= desde && fechaEndoso <= hasta;
        });
      }
    }
  }
};
</script>

<style scoped>
#trading-container {
  margin-top: 2rem;
  overflow: visible !important;
}

</style>
